module.exports = __webpack_public_path__ + "static/media/Vision_355x237.86fceb98.jpg";